import { FC } from 'react';

import { IconProps } from '.';

export const CheckedCircle: FC<IconProps> = ({
  width = 20,
  height = 20,
  color = '#16A34A',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99956 0.833984C4.94687 0.833984 0.833008 4.94785 0.833008 10.0005C0.833008 15.0531 4.94687 19.1671 9.99956 19.1671C15.0522 19.1671 19.1661 15.0531 19.1661 10.0005C19.1661 4.94785 15.0522 0.833984 9.99956 0.833984ZM9.99956 2.50063C14.1515 2.50063 17.4995 5.84859 17.4995 10.0005C17.4995 14.1524 14.1514 17.5004 9.99956 17.5004C5.84761 17.5004 2.49965 14.1525 2.49965 10.0005C2.49965 5.84859 5.84761 2.50063 9.99956 2.50063ZM13.1604 6.91141L8.74957 11.3222L6.83876 9.41138C6.68249 9.25513 6.47055 9.16735 6.24956 9.16735C6.02858 9.16735 5.81664 9.25513 5.66036 9.41138C5.50411 9.56765 5.41634 9.77959 5.41634 10.0006C5.41634 10.2216 5.50411 10.4335 5.66036 10.5898L8.16033 13.0897C8.31662 13.246 8.52855 13.3337 8.74953 13.3337C8.97051 13.3337 9.18245 13.246 9.33873 13.0897L14.3387 8.08981C14.4949 7.93354 14.5827 7.7216 14.5827 7.50061C14.5827 7.27962 14.4949 7.06768 14.3387 6.91141C14.1824 6.75516 13.9705 6.66738 13.7495 6.66738C13.5285 6.66738 13.3166 6.75516 13.1604 6.91141Z"
      fill={color}
    />
  </svg>
);
